import request from '@/utils/request'

export function add(data) {
  return request({
    url: '/DiseaseNature/add',
    method: 'post',
    data
  })
}

export function edit(data) {
  return request({
    url: '/DiseaseNature/edit',
    method: 'post',
    data
  })
}
